import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = { key: 0 }

import { useRouter } from "vue-router";
//import Lucide from "../../base-components/Lucide";
import { FormattedMenu, linkTo } from "./main-menu";
import {checkTypeOfIcon, substractNameOfIcon} from "@wpmss/ts-icons-helper"

interface MenuProps {
  class?: string | object;
  menu: FormattedMenu;
  isRoot: boolean;
  layout: "rubick" | "enigma" | "icewall" | "tinker";
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TopMenuLink',
  props: {
    class: null,
    menu: null,
    isRoot: { type: Boolean },
    layout: null
  },
  setup(__props: any) {

const props = __props as {
  class?: string | object;
  menu: FormattedMenu;
  isRoot: boolean;
  layout: "rubick" | "enigma" | "icewall" | "tinker";
}

const router = useRouter();
// @ts-ignore


return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Lucide = _resolveComponent("Lucide")!

  return (_openBlock(), _createElementBlock("a", {
    key: props.menu.title,
    href: 
      props.menu.subMenu && props.menu.subMenu.length > 0
        ? 'javascript:;'
        : 'top-menu/management/' + props.menu.href
    ,
    class: _normalizeClass([
      {
        'h-[55px] rounded-full xl:rounded-b-none xl:rounded-t-[1rem] flex items-center text-white relative':
          __props.layout === 'rubick',
        'px-5 mr-1': __props.isRoot && __props.layout === 'rubick',
        'px-0 mr-0': !__props.isRoot && __props.layout === 'rubick',
        'z-10 bg-slate-100 dark:bg-darkmode-700':
          __props.isRoot && props.menu.active && __props.layout === 'rubick',

        'before:content-[\'\'] before:w-[20px] before:h-[20px] before:-ml-[20px] before:rotate-90 before:scale-[1.04] before:bg-[length:100%] before:bg-menu-corner before:absolute before:bottom-0 before:left-0 before:hidden before:xl:block dark:before:bg-menu-corner-dark':
          __props.isRoot && props.menu.active && __props.layout === 'rubick',
        'after:content-[\'\'] after:w-[20px] after:h-[20px] after:-mr-[20px] after:rotate-180 after:scale-[1.04] after:bg-[length:100%] after:bg-menu-corner after:absolute after:bottom-0 after:right-0 after:hidden after:xl:block dark:after:bg-menu-corner-dark':
          __props.isRoot && props.menu.active && __props.layout === 'rubick',
      },
      {
        'h-[55px] flex items-center px-5 mr-1 text-slate-600 relative rounded-full xl:rounded-xl':
          __props.layout === 'enigma',
        'mt-[3px]': __props.isRoot && __props.layout === 'enigma',
        'bg-slate-100 text-primary dark:bg-darkmode-700':
          __props.isRoot && props.menu.active && __props.layout === 'enigma',
        'before:content-[\'\'] before:hidden xl:before:block before:inset-0 before:rounded-xl before:absolute before:border-b-[3px] before:border-solid before:border-black/[0.08] dark:before:border-black/[0.08]':
          __props.isRoot && props.menu.active && __props.layout === 'enigma',
        'after:content-[\'\'] after:w-[20px] after:h-[80px] after:bg-menu-active after:bg-no-repeat after:bg-cover after:absolute after:left-0 after:right-0 after:bottom-0 after:mx-auto after:transform after:rotate-90 after:hidden xl:after:block after:dark:bg-menu-active-dark':
          __props.isRoot && props.menu.active && __props.layout === 'enigma',
        'px-0 mr-0': !__props.isRoot && __props.layout === 'enigma',

        // Animation
        'after:opacity-0 after:-mb-[74px] after:animate-[0.3s_ease-in-out_1s_active-top-menu-chevron] after:animate-fill-mode-forwards':
          __props.isRoot && props.menu.active && __props.layout === 'enigma',
      },
      {
        'h-[55px] xl:h-[47px] flex items-center px-5 mr-1 text-white relative rounded-full xl:rounded-lg':
          __props.layout === 'icewall',
        'px-0 mr-0': !__props.isRoot && __props.layout === 'icewall',
        'mt-[3px]': __props.isRoot && __props.layout === 'icewall',
        'bg-slate-100 dark:bg-darkmode-700 xl:bg-primary':
          __props.isRoot && props.menu.active && __props.layout === 'icewall',
        'before:content-[\'\'] before:hidden xl:before:block before:inset-0 before:bg-white/[0.08] before:rounded-lg before:absolute before:border-b-[3px] before:border-solid before:border-black/10 before:dark:border-black/10':
          __props.isRoot && props.menu.active && __props.layout === 'icewall',
        'after:content-[\'\'] after:animate-[0.3s_ease-in-out_1s_active-top-menu-chevron] after:animate-fill-mode-forwards after:hidden xl:after:block after:w-[20px] after:h-[80px] after:-mb-[74px] after:bg-menu-active after:bg-no-repeat after:bg-cover after:absolute after:left-0 after:right-0 after:bottom-0 after:mx-auto after:transform after:rotate-90 after:opacity-0 dark:after:bg-menu-active-dark':
          __props.isRoot && props.menu.active && __props.layout === 'icewall',
      },
      {
        'h-[55px] flex items-center px-5 mr-1 text-white relative rounded-full xl:rounded-xl':
          __props.layout === 'tinker',
        'mt-[3px]': __props.isRoot && __props.layout === 'tinker',
        'bg-slate-100 xl:bg-primary dark:bg-darkmode-700':
          __props.isRoot && props.menu.active && __props.layout === 'tinker',
        'before:content-[\'\'] before:hidden xl:before:block before:inset-0 before:bg-white/[0.08] before:rounded-xl before:absolute before:border-b-[3px] before:border-solid before:border-black/10 before:dark:border-black/10 before:dark:bg-darkmode-700':
          __props.isRoot && props.menu.active && __props.layout === 'tinker',
        'px-0 mr-0': !__props.isRoot && __props.layout === 'tinker',
      },
      props.class,
    ]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(linkTo)(props.menu, _unref(router), $event, props.layout)))
  }, [
    _createElementVNode("div", {
      class: _normalizeClass([
        {
          'dark:text-slate-400': __props.layout === 'rubick',
          'text-primary dark:text-white':
            __props.isRoot && props.menu.active && __props.layout === 'rubick',

          'before:content-[\'\'] before:z-[-1] before:absolute before:w-full before:h-full before:top-0 before:left-0 before:rounded-full xl:before:rounded-b-none xl:before:rounded-t-lg before:transition before:ease-in before:duration-100':
            !props.menu.active && __props.layout === 'rubick',
        },
        {
          'z-10 dark:text-slate-400': __props.layout === 'enigma',
          'dark:text-white': __props.isRoot && props.menu.active && __props.layout === 'enigma',
        },
        {
          'z-10 dark:text-slate-400': __props.layout === 'icewall',
          'text-black xl:text-white dark:text-white':
            __props.isRoot && props.menu.active && __props.layout === 'icewall',
        },
        {
          'z-10 dark:text-slate-400': __props.layout === 'tinker',
          '-mt-[3px]': __props.isRoot && __props.layout === 'tinker',
          'dark:text-white text-primary xl:text-white':
            __props.isRoot && props.menu.active && __props.layout === 'tinker',
        },
      ])
    }, [
      (props.menu.menu_icon != 'no icon')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_unref(checkTypeOfIcon)(props.menu.rec_menu_icon_parent) == 'FontAwesome')
              ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                  key: 0,
                  class: "h-7",
                  icon: _unref(substractNameOfIcon)(props.menu.menu_icon)
                }, null, 8, ["icon"]))
              : _createCommentVNode("", true),
            (_unref(checkTypeOfIcon)(props.menu.rec_menu_icon_parent) == 'Lucide')
              ? (_openBlock(), _createBlock(_component_Lucide, {
                  key: 1,
                  icon: props.menu.menu_icon,
                  class: ""
                }, null, 8, ["icon"]))
              : _createCommentVNode("", true),
            (_unref(checkTypeOfIcon)(props.menu.rec_menu_icon_parent) == 'HeroIcon')
              ? (_openBlock(), _createBlock(_resolveDynamicComponent(props.menu.menu_icon), {
                  key: 2,
                  class: "w-9"
                }))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass([
        {
          'ml-3 flex items-center whitespace-nowrap dark:text-slate-400':
            __props.layout !== 'tinker',
          'text-black font-medium dark:text-white':
            __props.isRoot &&
            props.menu.active &&
            (__props.layout === 'rubick' || __props.layout === 'enigma'),
          'w-full': !__props.isRoot && __props.layout !== 'tinker',
        },
        {
          'text-black xl:text-white font-medium dark:text-white':
            __props.isRoot && props.menu.active && __props.layout === 'icewall',
        },
        {
          'ml-3 flex items-center whitespace-nowrap z-10 dark:text-slate-400':
            __props.layout === 'tinker',
          '-mt-[3px]': __props.isRoot && __props.layout === 'tinker',
          'font-medium dark:text-white text-slate-800 xl:text-white':
            __props.isRoot && props.menu.active && __props.layout === 'tinker',
          'w-full': !__props.isRoot && __props.layout === 'tinker',
        },
      ])
    }, [
      _createTextVNode(_toDisplayString(_ctx.$t(props.menu.title)) + " ", 1),
      (props.menu.subMenu && props.menu.subMenu.length > 0)
        ? (_openBlock(), _createBlock(_component_Lucide, {
            key: 0,
            icon: "ChevronDown",
            class: _normalizeClass([
          'hidden w-4 h-4 transition duration-100 ease-in xl:block',
          { 'ml-2': __props.isRoot },
          { 'ml-auto': !__props.isRoot },
        ])
          }, null, 8, ["class"]))
        : _createCommentVNode("", true)
    ], 2)
  ], 10, _hoisted_1))
}
}

})